import { flatten } from 'lodash';
import { utils } from './../../helpers';

/*
Group given objects by field.
For example:
objects is: [
  {job_id: 30133, name: 'DISPATCHEDBY', value: 'Nightly'},
  {job_id: 30133, name: 'Node', value: 'Win10'}
field is: 'job_id'
the result is:
{30133:
  {
    'DISPATCHEDBY': 'Nightly',
    'Node': 'Win10',
    ...
  }
}
*/
const groupParamsMetrics = (objects, field) =>
{
  return objects.reduce((result, object) => {
    const key = object[field];
    const name = object['name'];
    const value = object['value'];
    if (!result[key])
    {
      result[key] = {};
    }
    result[key][name] = value;
    return result;
  }, {});
};

/*
Group objects' valueField by given keyField.
For example:
The objects is: [
  {job_id: 1029, label: 'label1'},
  {job_id: 1029, label: 'label2'}
]
The result is:
{
  1029: ['label1', 'label2']
}
*/
const groupObjectsToKeyValues = (objects, keyField, valueField) =>
{
  return objects.reduce((result, object) => {
    const key = object[keyField];
    result[key] = result[key] || [];
    const value = object[valueField];
    result[key].push(value);
    return result;
  }, {});
};

/*
Handle the objects whose field is not unique of each other.
Group the objects by given field,
then return those objects whose field is included in the args
*/
const propertyAccumulatorFilter = (args, objects, field) => {
  const ids = args && args.ids || [];
  const objectsByField = utils.propertyAccumulatorReducer(objects, field);
  const filteredObjects = flatten(ids.map(id => objectsByField[id]).filter(p => p));
  return filteredObjects;
};


/*
Handle those payloads whose field is unique of each other.
Filter the payloads to only return those payloads whose field
is included in the args
*/
export const payloadsByIdHandler = (args, payloads, field) => {
  const ids = args && args.ids || [];
  const filteredPayloads = payloads.filter(
    payload => payload[field] && ids.includes(payload[field].toString()));
  return filteredPayloads;
};

/*
Filter the payloads by calling propertyAccumulatorFilter(see above).
And return the result of groupParamsMetrics(see above)
which is a {key: {name1: value1, name2: value2, ...}}
*/
export const paramsMetricsPayloadsHandler = (args, payloads, field) => {
  let filteredPayloads = propertyAccumulatorFilter(args, payloads, field);
  filteredPayloads = groupParamsMetrics(filteredPayloads, field);
  return filteredPayloads;
};

/*
Filter the payloads by calling propertyAccumulatorFilter(see above).
And return the result of groupObjectsToKeyValues(see above)
which is a {key: [value1, value2,...]}
*/
export const payloadsToKeyValuesHandler = (args, payloads, keyField, valueField) => {
  let filteredPayloads = propertyAccumulatorFilter(args, payloads, keyField);
  filteredPayloads = groupObjectsToKeyValues(filteredPayloads, keyField, valueField);
  return filteredPayloads;
};

/*
Filter the payloads, only return those payloads whose field
is less than or equal to any given args
*/
export const payloadsByDateHandler = (args, payloads, field) => {
  const unixTimestamps = args && args.ids || [];
  const filteredPayloads = payloads.filter(
    payload => payload[field] && unixTimestamps.some(
      timestamp => timestamp >= new Date(payload[field]).getTime() / 1000)
  );
  return filteredPayloads;
};

/*
Filter the payloads, only return those payloads whose field
is included in the given args
*/
export const payloadsByNameHandler = (args, payloads, field) => {
  let names = args && args.ids || [];
  names = names.map(name => name.toLowerCase());
  const filteredPayloads = payloads.filter(
    payload => payload[field] && names.includes(payload[field].toString().toLowerCase()));
  return filteredPayloads;
};




// WEBPACK FOOTER //
// src/actions/signalRHub/hubPayloadsHandler.js